export default "__VITE_ASSET__Cgb8IgoO__"